// extracted by mini-css-extract-plugin
export default {"wrapper":"CheckboxWrapper_wrapper__89+D5","active":"CheckboxWrapper_active__mR4sJ","checkbox":"CheckboxWrapper_checkbox__V--+6","name":"CheckboxWrapper_name__5eAdG"};